<div class="card-wrapper">
  <!-- RECENT ORDER ALERT BANNER -->
  <div
    class="order-message-banner"
    [ngClass]="
      recentOrderViewModel?.bannerMessage ===
      recentOrderTileBannerMessage.submittedModifiableOrder
        ? 'green-banner'
        : 'yellow-banner'
    "
    data-cy="recent-order-banner"
    *ngIf="
      recentOrderViewModel.bannerMessage !== '' &&
      !!recentOrderViewModel.bannerMessage
    "
  >
    <div data-cy="recent-order-alert-message-text">
      <ion-icon name="alert-circle-outline"></ion-icon>
      <div>
        {{ recentOrderViewModel.bannerMessage | translate }}
      </div>
    </div>
  </div>

  <ion-card data-cy="home-page-recent-orders-section" class="home-my-orders">
    <ion-card-header data-cy="home-page-recent-orders-header-section">
      <div
        data-cy="home-page-recent-orders-header-text"
        class="my-recent-orders"
      >
        {{ 'i18n.common.myRecentOrders' | translate }}
      </div>
      <ion-button
        class="usf-green-link-button view-all-orders-button"
        data-cy="home-page-view-orders-button"
        (click)="viewMyOrdersClicked()"
        >{{ 'i18n.home.viewAllOrders' | translate }}</ion-button
      >
    </ion-card-header>
    <div class="order-status-info">
      <div>
        <!-- ORDER ICON AND STATUS -->
        <div
          [ngClass]="determineOrderStatusClass()"
          *ngIf="!recentOrderViewModel?.noRecentOrder"
          class="recent-order-exists"
        >
          <img
            src="{{ recentOrderViewModel?.orderStatusIcon }}"
            alt=""
            class="order-icon"
            height="16"
          />
          {{ this.recentOrderViewModel?.orderStatusDisplayTitle | translate }}
          <br />
        </div>
        <div
          class="no-recent-order"
          *ngIf="recentOrderViewModel?.noRecentOrder"
        >
          <img
            src="{{ recentOrderViewModel?.orderStatusIcon }}"
            alt=""
            class="order-icon"
            height="16"
          />
          {{ 'i18n.home.recentOrdersTile.noRecentOrdersMessage' | translate }}
        </div>

        <!-- SHIPPING TYPE -->
        <ng-container *ngIf="recentOrderViewModel?.hasShippingType">
          <span
            class="shipping-text"
            *ngIf="
              recentOrderViewModel?.recentOrder?.orderHeader?.orderType !== 'VS'
            "
            data-cy="recent-order-usf-shipping-text"
          >
            <span>
              {{ 'i18n.home.recentOrdersTile.orderNum' | translate }}
              {{
                recentOrderViewModel?.recentOrder.orderHeader.tandemOrderNumber
              }}</span
            >

            &nbsp;|&nbsp;{{
              'i18n.home.recentOrdersTile.usFoodsDelivery' | translate
            }}</span
          >
          <span
            *ngIf="
              recentOrderViewModel?.recentOrder?.orderHeader?.orderType === 'VS'
            "
            class="shipping-text"
            data-cy="recent-order-direct-shipping-text"
          >
            <span>
              {{ 'i18n.home.recentOrdersTile.orderNum' | translate }}
              {{
                recentOrderViewModel?.recentOrder.orderHeader.tandemOrderNumber
              }}</span
            >&nbsp;| &nbsp;<img
              src="assets/icon/direct-no-outline.svg"
              class="direct-icon"
              alt="Direct Order"
              height="10"
            />
            {{ 'i18n.orderStatusPage.shipping' | translate }}
          </span>
        </ng-container>
      </div>
    </div>
    <div
      class="order-detail-info"
      *ngIf="
        !recentOrderViewModel?.noOrderCard &&
        !recentOrderViewModel?.noRecentOrder
      "
    >
      <div class="order-detail-info_labels">
        <div data-cy="recent-orders-placed-label">
          {{ 'i18n.home.recentOrdersTile.orderPlaced' | translate }}
        </div>
        <div data-cy="recent-orders-each-cases-label">
          {{ 'i18n.home.recentOrdersTile.eachesCases' | translate }}
        </div>
        <div data-cy="recent-orders-total-label">
          {{ 'i18n.home.recentOrdersTile.total' | translate }}
        </div>
      </div>
      <div class="order-detail-info_text">
        <div data-cy="recent-orders-placed-text">
          {{
            !!recentOrderViewModel?.orderPlacedDate
              ? (recentOrderViewModel?.orderPlacedDate
                | date: 'M/d/yyyy' : 'GMT')
              : '--'
          }}
        </div>
        <div data-cy="recent-orders-each-cases-text">
          <ng-container
            *ngIf="
              recentOrderViewModel?.totalCases > 0 ||
              recentOrderViewModel?.totalEaches > 0
            "
            >{{ recentOrderViewModel?.totalCases || '0' }} CS /
            {{ recentOrderViewModel?.totalEaches || '0' }} EA
          </ng-container>
          <ng-container
            *ngIf="
              !recentOrderViewModel?.totalCases &&
              !recentOrderViewModel?.totalEaches
            "
          >
            --
          </ng-container>
        </div>
        <div data-cy="recent-orders-total-text">
          <ng-container
            *ngIf="
              recentOrderViewModel.currentCustomer.ogPrintPriceInd !== 'N';
              else noCostCustomerTotal
            "
            >{{ recentOrderViewModel?.orderTotal || '0' | currency }}
          </ng-container>
          <ng-template #noCostCustomerTotal>
            {{ 'i18n.common.notApplicable' | translate }}
          </ng-template>
        </div>
      </div>
    </div>
    <div
      data-cy="home-page-my-orders-buttons-section"
      [ngClass]="
        recentOrderViewModel?.noRecentOrder ||
        recentOrderViewModel?.noOrderCard ||
        (!recentOrderViewModel?.noRecentOrder &&
          !recentOrderViewModel?.noOrderCard &&
          recentOrderViewModel?.recentOrder?.orderHeader?.orderStatus !==
            'IN_PROGRESS' &&
          !recentOrderViewModel?.isEditable)
          ? 'home-my-orders-btn-centered'
          : 'home-my-orders-btns'
      "
    >
      <ion-button
        data-cy="home-page-view-orders-button"
        [ngClass]="
          platformService?.platformType !==
          platformService?.platformEnum?.mobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-button'
        "
        (click)="recentOrderButtonClicked()"
        *ngIf="
          !recentOrderViewModel?.noRecentOrder &&
          !recentOrderViewModel?.noOrderCard
        "
      >
        {{ this.recentOrderViewModel?.actionButtonText | translate }}
      </ion-button>
      <ion-button
        data-cy="home-page-create-order-button"
        *ngIf="
          recentOrderViewModel?.noRecentOrder ||
          recentOrderViewModel?.noOrderCard
        "
        [ngClass]="
          platformService?.platformType !==
            platformService?.platformEnum?.mobile &&
          (recentOrderViewModel?.noRecentOrder ||
            recentOrderViewModel?.noOrderCard)
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-button'
        "
        (click)="createNewOrderClicked()"
      >
        {{ 'i18n.home.createOrder' | translate }}
      </ion-button>

      <ion-button
        data-cy="home-page-create-order-button"
        *ngIf="
          !recentOrderViewModel?.noRecentOrder &&
          !recentOrderViewModel?.noOrderCard &&
          (recentOrderViewModel?.recentOrder?.orderHeader?.orderStatus ===
            'IN_PROGRESS' ||
            !!recentOrderViewModel?.isEditable)
        "
        [ngClass]="
          platformService?.platformType !==
            platformService?.platformEnum?.mobile &&
          (!recentOrderViewModel?.noRecentOrder ||
            !recentOrderViewModel?.noOrderCard)
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-button'
        "
        (click)="createNewOrderClicked()"
      >
        {{ 'i18n.home.createOrder' | translate }}
      </ion-button>
    </div>
  </ion-card>
</div>
